import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IFairePay } from '@faire/web-api--source/indigofair/data/IFairePay';
import { IFairePayTermsOfService } from '@faire/web-api--source/indigofair/data/IFairePayTermsOfService';

export namespace IFairePayEnrollmentInfo {
  export enum Status {
    STATUS_UNKNOWN = 'STATUS_UNKNOWN',
    ENROLLED = 'ENROLLED',
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE = 'INELIGIBLE',
    CLOSED = 'CLOSED',
  }

  /**
   * Return an instance of IFairePayEnrollmentInfo with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IFairePayEnrollmentInfo>
  ): IFairePayEnrollmentInfo =>
    ({
      available_payment_preferences: [],
      ...(partial ?? {}),
    }) as IFairePayEnrollmentInfo;
}

export interface IFairePayEnrollmentInfo {
  /**
   * @deprecated
   */
  is_eligible: boolean | undefined;
  reward_bps: number | undefined;
  outstanding_invoice_reward_amount: IFaireMoney | undefined;
  /**
   * @deprecated
   */
  tos_url: string | undefined;
  available_payment_preferences: Array<
    keyof typeof IFairePay.PaymentPreference
  >;
  status: keyof typeof IFairePayEnrollmentInfo.Status | undefined;
  terms_of_service: IFairePayTermsOfService | undefined;
  has_post_enrollment_credit_offer: boolean | undefined;
  pre_enroll_outstanding_invoice_reward_amount: IFaireMoney | undefined;
  one_time_discount_amount: IFaireMoney | undefined;
  enrolment_state: keyof typeof IFairePay.EnrolmentState | undefined;
}
